import { useState, useEffect, useContext } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import useFetchData from '../../../hooks/useFetchData';
import useSort from '../../../hooks/useSort';
import Filter from '../../Filter';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { tableHeadersClients, columnsClients } from '../utils';
import SnackBar from 'components/SnackBar';
import translating from '../translate.json';
import GlobalContext from '../../../contexts';
import ExcelDownload from 'components/ExcelDownload';

const CustomersList = () => {
  const navigate = useNavigate();
  const { organizationsList, typeEnum, setLink, currentUser } =
    useContext(GlobalContext);
  const { data: customersData, loading } = useFetchData('client');
  const [filtedCustomers, setFilteredCustomers] = useState();
  const { showFilters, toggle } = useSort();
  const [searchParams] = useSearchParams();
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    if (customersData?.length) setFilteredCustomers(customersData);
  }, [customersData]);

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  const onFilter = (filteredData) => {
    setFilteredCustomers(filteredData);
  };

  const onResetFilters = () => {
    setFilteredCustomers(customersData);
  };

  const actionsOrgsList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredCustomers(customersData);
        toggle(!showFilters);
      }
    }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: [
        'id',
        'email',
        'first_name',
        'last_name',
        'full_name',
        'ssn',
        'address',
        'mobile'
      ]
    },
    {
      type: 'date',
      subType: 'fromDate',
      label: translating.fromDate,
      name: 'fromDate',
      field: 'createdAt'
    },
    {
      type: 'date',
      subType: 'toDate',
      label: translating.toDate,
      name: 'toDate',
      field: 'createdAt'
    },
    {
      type: 'select',
      label: translating.status,
      name: 'isActive',
      options: [
        { id: true, name: 'פעיל' },
        { id: false, name: 'חסום' }
      ],
      isId: true
    },
    {
      type: 'select',
      label: translating.type,
      name: 'client_type',
      options: typeEnum,
      isId: true
    },
    {
      type: 'select',
      label: translating.relateOrg,
      name: 'organizationId',
      options: organizationsList,
      isId: true
    },
    {
      type: 'select',
      label: translating.allowEmails,
      name: 'allow_rceive_emails',
      options: [
        { id: true, name: 'פעיל' },
        { id: false, name: 'חסום' }
      ],
      isId: true
    }
  ];

  const roleUser = currentUser.role.name;
  const allowdRules = ['Admin', 'Sales', 'Manager'];
  const createNewClient =
    allowdRules.indexOf(roleUser) > -1
      ? { handleClick: () => setLink('add') }
      : {};

  return (
    <div className="customers-list">
      <ListHeader
        title={translating.customersListTitle}
        actions={actionsOrgsList}
        newItem={createNewClient}
      ></ListHeader>
      {filtedCustomers?.length ? (
        <ExcelDownload
          data={filtedCustomers}
          filename={'clients_data.csv'}
        ></ExcelDownload>
      ) : null}
      {showFilters && organizationsList && (
        <Filter
          fields={sortFields}
          data={customersData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      {filtedCustomers && (
        <>
          <div className="count-clients">{`נמצאו ${filtedCustomers?.length} לקוחות `}</div>
          <div className="customers-list-wrapper-table">
            {customersData && !loading && (
              <TablePagination
                headers={tableHeadersClients}
                columns={columnsClients}
                rows={filtedCustomers}
                pagination={true}
                useUId={true}
                handleRowClick={(id) => {
                  navigate(`/clients/${id}`);
                }}
              ></TablePagination>
            )}
          </div>
        </>
      )}
      {showSnackbar && (
        <SnackBar
          msg={'לקוח נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default CustomersList;
